<div class="report-adjustments-without-analisysplus" fxLayout="column" fxFlex>
    <div class="report-adjustments-without-analisysplus-header">
        <p class="report-adjustments-without-analisysplus-introduction">
            Simule os próximos resultados da sua empresa através da
            <strong>Projeção</strong>, estime despesas e receitas e acompanhe os
            resultados através do <strong>Orçamento</strong>, defina e acompanhe
            o <strong>Objetivo</strong> para cada indicador.
        </p>
        <div class="report-adjustments-without-analisysplus-image-container">
            <img
                src="/images/analise-plus-head.png"
                alt="Ajustes sem Análise Plus"
            />
        </div>
    </div>
    <div class="horizontal-divider"></div>
    <div class="card-container">
        @for (indicador of indicadores; track $index) {
            <div class="card">
                <div class="card-header">
                    <p>{{ indicador.titulo }}</p>
                    <div class="card-header__actions">
                        <app-badge-rocket></app-badge-rocket>
                        <mat-slide-toggle
                            class="{{
                                !company.analysisPlusStatus ? 'disabled' : ''
                            }}"
                            [disabled]="!company.analysisPlusStatus"
                            [hideIcon]="true"
                            [checked]="indicador.active"
                        ></mat-slide-toggle>
                    </div>
                </div>
                <div class="card-image">
                    <img [src]="indicador.imagemSrc" [alt]="indicador.titulo" />
                </div>
                <p class="card-content">{{ indicador.descricao }}</p>

                @if ($index < indicadores.length - 1) {
                    <div class="horizontal-divider"></div>
                }
            </div>
        }
    </div>
    <div class="card-container" style="margin-top: var(--spacing-12)">
        @for (objetivo of objetivos; track objetivo) {
            <div class="card">
                <div class="card-header">
                    <p>{{ objetivo.titulo }}</p>
                    <div class="card-header__actions">
                        <app-badge-rocket></app-badge-rocket>
                        <mat-slide-toggle
                            class="{{
                                !company.analysisPlusStatus ? 'disabled' : ''
                            }}"
                            [disabled]="!company.analysisPlusStatus"
                            [hideIcon]="true"
                        ></mat-slide-toggle>
                    </div>
                </div>
                <div class="card-image">
                    <img [src]="objetivo.imagemSrc" [alt]="objetivo.titulo" />
                </div>
                <p class="card-content">{{ objetivo.descricao }}</p>
            </div>
        }
    </div>
</div>
<div class="button-container">
    <dsn-button
        class="button"
        label="Solicitar Análise Plus"
        type="accent"
        [size]="'large'"
        [width]="'full'"
        (click)="onRequestAnalysisPlus()"
    ></dsn-button>
</div>
